module.exports = __webpack_public_path__ + "static/media/s_sf_4.acea6435.png";